var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBangladesh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_16_1466)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16_1466",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16_1466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2819 3H0V23H34.2819V3Z",
    fill: "#2F6C50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4268 6.14029C19.2099 6.14029 22.2832 9.21361 22.2832 12.9967C22.2832 16.7864 19.2166 19.853 15.4268 19.853C11.6438 19.853 8.57045 16.7864 8.57045 12.9967C8.57045 9.20691 11.6438 6.14029 15.4268 6.14029Z",
    fill: "#E01C4A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16_1466",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_1466"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_1466",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBangladesh);
export default __webpack_public_path__ + "static/media/Bangladesh.add7dfdbb0eed97a7217ddb4a0022a71.svg";
export { ForwardRef as ReactComponent };